module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-60x60-precomposed-7c422e2836088aad5048185df10e07b1.png";